export default "/assets/images/highway-pollution-video.mp4?34a4d8c3034df82d96e059cc01f94d08";